import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../../shared/services';

@Component({
  selector: 'app-cost-cover-info',
  templateUrl: './cost-cover-info.component.html',
  styleUrls: ['./cost-cover-info.component.scss']
})
export class CostCoverInfoComponent implements OnInit {

  constructor(
    private util: UtilService
  ) { }
  @Input() section;
  isMobile: any;
  breakpoints = {
    600: { perView: 1.8, focusAt: 0, showArrows: false },
    992: { perView: 1, focusAt: 0 }
  };
  ngOnInit() {
    this.isMobile = this.util.isMobile();
  }

}
